import {
  ActionIcon,
  Badge,
  Box,
  Button,
  Flex,
  Menu,
  Text,
} from "@mantine/core";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import { _localization } from "../../config/location";
import { useDeferredValue, useEffect, useState } from "react";
import { MessageResponse } from "../../model/MessageResponse";
import { repositoryMdm } from "../../_base/_const/_constVar";
import React from "react";
import { formatDateTransfer } from "../../common/FormatDate/FormatDate";
import { IconCheck, IconRefresh, IconTrash } from "@tabler/icons-react";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";

const ModalsDebtBricks = ({ id }: { id: number }) => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 50,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "reciptNumber",
        header: "Mã gạch nợ",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue ? (
            <Badge variant="dot" color="teal">
              {renderedCellValue}
            </Badge>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "amountDebt",
        header: "Tiền gạch nợ",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue).toLocaleString()} đ
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "amountTotal",
        header: "Tổng tiền đơn hàng",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue).toLocaleString()} đ
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "amountRemaining",
        header: "Số tiền còn lại",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text size="12.5px" fw={500}>
              {Number(renderedCellValue).toLocaleString()} đ
            </Text>
          ) : (
            <></>
          ),
      },
      {
        accessorKey: "orderamount",
        header: "Lần gạch nợ",
      },
      {
        accessorKey: "createDate",
        header: "Ngày gạch nợ",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        Cell: ({ row }) => (
          <Flex gap={"md"} align={"center"}>
            <Menu>
              <Menu.Target>
                <ActionIcon variant="light" color="red">
                  <IconTrash />
                </ActionIcon>
              </Menu.Target>
              <Menu.Dropdown>
                <Box m={5}>
                  <Text fw={500} size="14px">
                    Bạn có chắc muốn xóa phiếu gạch nợ này ?
                  </Text>
                  <Flex justify={"center"} align={"center"} gap={"md"} mt={10}>
                    <Button
                      leftSection={<IconCheck size={14} />}
                      size="xs"
                      color="red"
                      onClick={() =>
                        handleDeleteDebtBricks(row.original.reciptNumber)
                      }
                    >
                      Xác nhận
                    </Button>
                  </Flex>
                </Box>
              </Menu.Dropdown>
            </Menu>
          </Flex>
        ),
      },
    ],
    []
  );

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/SyncData/get-gach-no-don?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}&orderId=${id}`;

      const res = await repositoryMdm.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        const sortedResult = [...result].sort(
          (a, b) => Number(a.orderamount) - Number(b.orderamount)
        );
        setData(sortedResult);
        setRowCount(res.totalCount);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const handleDeleteDebtBricks = async (code: string) => {
    const res = await repositoryMdm.get<MessageResponse<any>>(
      `/api/v1/SyncData/xoa-gach-no-don?code=${code}&orderId=${id}`
    );

    if (res && res.success) {
      NotificationExtension.Success("Xóa gạch nợ đơn thành công !");
      setTimeout(() => {
        fetchData();
      }, 1000);
    }
  };

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    fetchData();
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (300 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: [],
        right: [],
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    renderBottomToolbarCustomActions: ({ table }) => (
      <Button
        leftSection={<IconRefresh />}
        color="blue"
        onClick={() => fetchData()}
      >
        Cập nhật dữ liệu
      </Button>
    ),
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["50", "100", "200"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  return (
    <>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default ModalsDebtBricks;
